import { useQuery } from '@tanstack/react-query';
import { useApiAppLegacy } from '@/shared/api';
import { userConsentsQueryOptions } from './user-consents.query-options';

/**
 * 사용자 수신·마케팅 동의 query — `userConsentsQueryOptions` (entity SSOT) 를 React 컨텍스트에 적용.
 */
export function useUserConsentsQuery() {
  const api = useApiAppLegacy();
  return useQuery(userConsentsQueryOptions(api));
}
